export const ActionTypes = {
  CREATE_MALL: 'CREATE_MALL',
  CREATE_STORE: 'CREATE_STORE',
};
